import React, { useState, useEffect } from 'react';
import { messageTypeEnum } from '../../enum';

const BasicMessage = (props) => {
	const { message, type } = props;
	const [className, setClassName] = useState('ui hidden message');

	const closeTimer = () => {
		setTimeout(() => {
			props.onClick();
			if(type === messageTypeEnum.success){
				//Browser refresh
				window.location.reload();
			}
		}, 3000);
	};

	useEffect(() => {
		switch (type) {
			case messageTypeEnum.error:
				setClassName('ui error message');
				break;
			case messageTypeEnum.success:
				setClassName('ui success message');
				closeTimer();
				break;
			case messageTypeEnum.warning:
				setClassName('ui warning message');
				break;
			default:
				setClassName('ui transition hidden message');
				break;
		}

	}, [type]);

	return (
		<div className="ui aligned grid">
			<div className={`column ${className}`}>
				<div className={className}>
					<i className="close icon" onClick={(e) => props.onClick()}></i>
					<div className="header">
						{message}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BasicMessage;